/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 03.12.17.
 */
import _ from "underscore";
class QueryParamParser {
    /**
     * Parses query parameter string and returns array of parameter objects in the form:
     *  [
     *      {
     *          name: paramName,
     *          op: paramOp,
     *          value: paramValue
     *      },
     *      ...
     *  ]
     * @param queryString
     */
    static parse(queryString) {
        let result = [];
        let expressions = queryString.split("&");
        for (let e of expressions) {
            let paramAndValue = e.split("=", 2);
            let paramAndOp = decodeURIComponent(paramAndValue[0]);

            let item = {
                value: decodeURIComponent(paramAndValue[1])
            };

            let m = paramAndOp.match(/^(.*\w)(\W*)$/);
            if (m.length > 2) {
                item.name = m[1];
                item.op = m[2];
            } else {
                item.name = paramAndOp;
            }
            result.push(item);
        }
        return result;
    }

    /**
     * Returns parsed query string as object in the form:
     *  {
     *      paramName: {
     *          op: paramOp,
     *          value: paramValue
     *      },
     *      paramName: [
     *          { op: paramOp, value: paramValue },
     *          ...
     *      ],
     *      ...
     *  }
     * @param queryString
     * @returns {object}
     */
    static parseAsObject(queryString) {
        let result = QueryParamParser.parse(queryString);
        let reduced = {};
        for (let e of result) {
            if (!reduced[e.name]) reduced[e.name] = { op: e.op, value: e.value };
            else {
                if (!_.isArray(reduced[e.name])) reduced[e.name] = [reduced[e.name]];
                reduced[e.name].push({op: e.op, value: e.value});
            }
        }
        return reduced;
    }
}

export default QueryParamParser;
